(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionSection {
    constructor(container) {
      this.container = container;
      this.productsContainer = container.querySelector('[data-products-container]');
      this.loadMoreBtn = container.querySelector('[data-load-more]');
      this.loadingIndicator = container.querySelector('[data-loading]');
      this.autoLoad = container.querySelector('.collection-grid').dataset.autoLoad === 'true';
      this.isLoading = false;

      if (this.loadMoreBtn) {
        this.init();
      }
    }

    init() {
      this.loadMoreBtn.addEventListener('click', () => this.loadMore());

      if (this.autoLoad) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && !this.isLoading) {
                this.loadMore();
              }
            });
          },
          { rootMargin: '200px' }
        );
        this.observer.observe(this.loadMoreBtn);
      }
    }

    async loadMore() {
      if (this.isLoading) return;

      const nextUrl = this.loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      this.isLoading = true;
      this.loadMoreBtn.disabled = true;
      this.loadingIndicator.hidden = false;

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newProducts = doc.querySelectorAll('[data-products-container] .collection-grid__item');
        newProducts.forEach(product => {
          this.productsContainer.appendChild(product.cloneNode(true));
        });

        const newLoadMoreBtn = doc.querySelector('[data-load-more]');
        if (newLoadMoreBtn) {
          this.loadMoreBtn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
          this.loadMoreBtn.disabled = false;
        } else {
          this.loadMoreBtn.remove();
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      } catch (error) {
        console.error('Error loading more products:', error);
        this.loadMoreBtn.disabled = false;
      } finally {
        this.isLoading = false;
        this.loadingIndicator.hidden = true;
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-section-type="collection"]');
    sections.forEach(section => new CollectionSection(section));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-slider-prev], [data-slider-next]');
      if (!btn) return;
      var wrapper = btn.closest('.center-slider-wrapper');
      var dotsContainer = wrapper && wrapper.querySelector('[data-slider-dots]');
      if (!dotsContainer) return;
      var dots = Array.from(dotsContainer.querySelectorAll('.slider-dot'));
      if (!dots.length) return;
      var activeIndex = dots.findIndex(function (d) { return d.classList.contains('is-active'); });
      if (activeIndex === -1) activeIndex = 0;
      var delta = btn.hasAttribute('data-slider-prev') ? -1 : 1;
      var nextIndex = Math.max(0, Math.min(dots.length - 1, activeIndex + delta));
      if (dots[nextIndex]) dots[nextIndex].click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
